import React, { FC } from 'react';
import styled, { css } from 'styled-components';

export interface SideAndMainProps {
  children: any;
}

const StyledSideAndMain = styled.div`
  ${({ theme: { space, media } }) => css`
    display: grid;
    grid-gap: ${space.lg};
    @media (min-width: ${media.xl}) {
      grid-template-columns: 256px 1fr;
      padding-right: ${space.xxl};

      > *:last-child {
        grid-column-start: 1;
        grid-row-start: 1;
      }
    }
  `};
`;

export const StyledSide = styled.aside`
  ${({ theme: { space, media } }) => css`
    @media (min-width: ${media.xl}) {
      padding-top: ${space.xl};
    }
  `};
`;

export const SideAndMain: FC<React.PropsWithChildren<SideAndMainProps>> = ({ children, ...rest }) => (
  <StyledSideAndMain {...rest}>{children}</StyledSideAndMain>
);
